import mitt from 'mitt'

export const CHECK_USER_FILES_EVENT = 'Notifications__checkUserFiles'

type CheckUserFilesPayload = Record<string, unknown> | Array<Record<string, unknown>> | undefined

type NotificationEvents = {
  [CHECK_USER_FILES_EVENT]: CheckUserFilesPayload;
}

const notificationsEmitter = mitt<NotificationEvents>()

export const emitCheckUserFiles = (payload?: CheckUserFilesPayload): void => {
  notificationsEmitter.emit(CHECK_USER_FILES_EVENT, payload)
}

export const onCheckUserFiles = (handler: (payload?: CheckUserFilesPayload) => void): void => {
  notificationsEmitter.on(CHECK_USER_FILES_EVENT, handler)
}

export const offCheckUserFiles = (handler: (payload?: CheckUserFilesPayload) => void): void => {
  notificationsEmitter.off(CHECK_USER_FILES_EVENT, handler)
}

export type { CheckUserFilesPayload }
